import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
// components
import Layout from "./Layout";
// pages
import Error from "../pages/error";

// context
import { useUserState } from "../context/UserContext";

import LoginLayout from "./LoginLayout/LoginLayout";
import WebVersionNotifier from "./WebVersionNotifier/WebVersionNotifier";
export default function App() {
  // global
  var { isAuthenticated, bootstrapped } = useUserState();

  if (!bootstrapped) {
    return null;
  }

  return (
    <HashRouter>
      <WebVersionNotifier />
      <Switch>
        <Route
          exact
          path="/"
          render={() => {
            try {
              const user = JSON.parse(localStorage.getItem("userDetail") || "{}");
              const role = String(user?.role || "").toUpperCase();
              if (role === "SCHOOLE") return <Redirect to="/app/addbranchschool" />;
              if (role === "TEACHER") return <Redirect to="/app/studentactivity" />;
              if (role === "PARENT") return <Redirect to="/app/assignment" />;
              if (role === "SUPERADMIN") return <Redirect to="/app/schooldetails" />;
            } catch {
              // fall through
            }
            return <Redirect to="/app/studentdetails" />;
          }}
        />
        {/* <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/dashboard" />}
        /> */}
        <PrivateRoute path="/app/" component={Layout} />
        {/* <PublicRoute path="/login" component={Login} /> */}
        <PublicRoute path="/montessori" component={LoginLayout} />
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/montessori/home",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (() => {
            // Allow opening "public" informational pages even when logged in.
            // Without this, navigating to /montessori/term or /montessori/privacy
            // auto-redirects to "/" and then to "/app/studentdetails".
            const path = props.location?.pathname || "";
            const allowedWhenAuthed = [
              "/montessori/term",
              "/montessori/privacy",
              "/montessori/problenwesolve",
              "/montessori/enquiry",
              "/montessori/about",
              "/montessori/contact",
              "/montessori/refund-cancellation",
            ];

            if (allowedWhenAuthed.some(p => path.startsWith(p))) {
              return React.createElement(component, props);
            }

            return (
              <Redirect
                to={{
                  pathname: "/",
                }}
              />
            );
          })() : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
